<template>
  <div>
    <div v-if="!loading && appointment !== null">
      <div v-if="isVirtual">
        <video-call
          :appointment="appointment"
        />
      </div>
      <div v-else-if="playback !== null">
        <mux-live-stream
          :appointment="appointment"
          :playback="playback"
        />
      </div>
    </div>
    <div v-else>
      Could not find an appointment
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { APPOINTMENT_TYPES } from '@/_utilities/Enums';
import VideoCall from './VideoCall';
import MuxLiveStream from './MuxLiveStream';
import { appointmentsService } from '../../_services';

export default {
  name: 'VideoRoom',
  components: {
    VideoCall, MuxLiveStream,
  },
  data() {
    return {
      appointment: null,
      playback: null,
      loading: true,
    };
  },
  computed: {
    isVirtual() {
      return this.appointment?.appointment_type === APPOINTMENT_TYPES.VIRTUAL;
    },
  },
  mounted() {
    console.log('mounted');
    axios.get(`${this.apiRoot()}/get_appointment/${this.$route.params.id}/`).then((resp) => {
      this.appointment = resp.data;
      console.log('app type', this.appointment.appointment_type);
      if (this.appointment.appointment_type !== APPOINTMENT_TYPES.VIRTUAL) {
        appointmentsService.fetchPlayback(this.appointment.pk).then((r) => {
          this.playback = r.data.playback_id;
        });
      }
      this.loading = false;
    });
  },
};
</script>
